import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "phone-body"
}
const _hoisted_2 = ["title"]
const _hoisted_3 = { class: "pc-ai-order-body" }
const _hoisted_4 = {
  key: 0,
  class: "pc-ai-order-list"
}
const _hoisted_5 = { class: "ai-order-pagination" }
const _hoisted_6 = { style: {"position":"sticky","top":"0"} }
const _hoisted_7 = { style: {"white-space":"nowrap"} }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { style: {"white-space":"nowrap"} }
const _hoisted_10 = { style: {"min-width":"100px","justify-content":"center","max-width":"200px","display":"flex","flex-wrap":"nowrap","align-items":"center"} }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "table-example-footer" }

import { useAiOrderStore } from '@/store/AiOrderTaskStore';
import Tools from '@/utils/Tools';
import { inject, ref, watch } from 'vue';
import EmptyComponent from '../GlobalComponents/EmptyComponent.vue';
import SignalRService from '@/typescript/Services/SignalRService';
import CloseFabButtonComponent from '../GlobalComponents/CloseFabButtonComponent.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'AIOrderTaskWindow',
  setup(__props) {

const aiOrderStore = useAiOrderStore();
const IsMobile = inject<boolean>("IsMobile");

watch([() => aiOrderStore.show, () => aiOrderStore.active, () => aiOrderStore.data.page], (_n, _o) => {
    if (_n[0]) {
        aiOrderStore.LoadDataAsync();
    }
}, {
    immediate: true
});



return (_ctx: any,_cache: any) => {
  const _component_var_tab = _resolveComponent("var-tab")!
  const _component_var_tabs = _resolveComponent("var-tabs")!
  const _component_var_divider = _resolveComponent("var-divider")!
  const _component_VarSpace = _resolveComponent("VarSpace")!
  const _component_VarEllipsis = _resolveComponent("VarEllipsis")!
  const _component_VarChip = _resolveComponent("VarChip")!
  const _component_VarCountTo = _resolveComponent("VarCountTo")!
  const _component_var_pagination = _resolveComponent("var-pagination")!
  const _component_var_table = _resolveComponent("var-table")!
  const _component_VarCard = _resolveComponent("VarCard")!
  const _component_VarOverlay = _resolveComponent("VarOverlay")!

  return (_unref(IsMobile))
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (_unref(aiOrderStore).show)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(CloseFabButtonComponent, {
                onOnClose: _cache[0] || (_cache[0] = ($event: any) => (_unref(aiOrderStore).show = false))
              }),
              _createElementVNode("div", {
                class: "pc-card",
                title: _ctx.$t('components.AIOrderTaskWindow.title')
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_var_tabs, {
                    style: {"height":"50px","min-height":"50px"},
                    active: _unref(aiOrderStore).active,
                    "onUpdate:active": _cache[1] || (_cache[1] = ($event: any) => ((_unref(aiOrderStore).active) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(aiOrderStore).effectStatusArr, (v) => {
                        return (_openBlock(), _createBlock(_component_var_tab, { key: v }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t(`components.AIOrderTaskWindow.${v}`)), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["active"]),
                  (_unref(aiOrderStore).data.total > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(aiOrderStore).data.list, (v, i) => {
                          return (_openBlock(), _createBlock(_component_VarSpace, {
                            direction: "column",
                            key: v.Id
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_var_divider),
                              _createVNode(_component_VarSpace, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_VarSpace, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_VarSpace, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t('components.AIOrderTaskWindow.rwd')), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_VarSpace, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_VarEllipsis, { class: "order-number" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(v.OrderNumber), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_VarSpace, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_VarSpace, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t('components.AIOrderTaskWindow.cp')), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_VarSpace, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(v.Product.Dn), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_VarSpace, {
                                justify: "space-between",
                                align: "center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_VarSpace, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_VarSpace, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t('components.AIOrderTaskWindow.gmfy')), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_VarChip, {
                                        size: "small",
                                        type: "info"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" $ " + _toDisplayString(_unref(Tools).TruncateDecimal(v.BuyCost ?? 0, 2)), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_VarSpace, { align: "center" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_VarSpace, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t('components.AIOrderTaskWindow.zsy')), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_VarChip, {
                                        size: "small",
                                        type: (v.TotalAmount ?? 0) >= 0 ? 'success' : 'danger'
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_VarCountTo, {
                                            duration: 300,
                                            to: v.TotalAmount ?? 0,
                                            precision: 8
                                          }, null, 8, ["to"])
                                        ]),
                                        _: 2
                                      }, 1032, ["type"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_VarSpace, { align: "center" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_VarSpace, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t('components.AIOrderTaskWindow.rws')), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_VarChip, {
                                        size: "small",
                                        type: "primary"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(v.TotalTaskCount ?? 0), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_VarSpace, { align: "center" }, {
                                default: _withCtx(() => [
                                  (_unref(aiOrderStore).effectStatusArr[_unref(aiOrderStore).active] == 'finish')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.AIOrderTaskWindow.startTime')), 1),
                                        _createElementVNode("span", null, _toDisplayString((v.StartTime && _unref(Tools).ConvertTimestamp(v.StartTime ?? 0)) || '--'), 1),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.AIOrderTaskWindow.overTime')), 1),
                                        _createElementVNode("span", null, _toDisplayString((v.OverTime && _unref(Tools).ConvertTimestamp(v.OverTime ?? 0)) || '--'), 1)
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.AIOrderTaskWindow.yxsj')), 1),
                                        _createElementVNode("span", null, _toDisplayString(_unref(aiOrderStore).GetRunTime(v)), 1)
                                      ], 64))
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128)),
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_component_var_pagination, {
                            "show-size-changer": false,
                            current: _unref(aiOrderStore).data.page,
                            "onUpdate:current": _cache[2] || (_cache[2] = ($event: any) => ((_unref(aiOrderStore).data.page) = $event)),
                            size: _unref(aiOrderStore).data.pageSize,
                            "onUpdate:size": _cache[3] || (_cache[3] = ($event: any) => ((_unref(aiOrderStore).data.pageSize) = $event)),
                            total: _unref(aiOrderStore).data.total
                          }, null, 8, ["current", "size", "total"])
                        ])
                      ]))
                    : (_openBlock(), _createBlock(EmptyComponent, {
                        key: 1,
                        style: {"width":"100%"}
                      }))
                ])
              ], 8, _hoisted_2)
            ]))
          : _createCommentVNode("", true)
      ], 64))
    : (_openBlock(), _createBlock(_component_VarOverlay, {
        key: 1,
        show: _unref(aiOrderStore).show,
        "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => ((_unref(aiOrderStore).show) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_VarCard, {
            title: _ctx.$t('components.AIOrderTaskWindow.title')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_var_tabs, {
                active: _unref(aiOrderStore).active,
                "onUpdate:active": _cache[4] || (_cache[4] = ($event: any) => ((_unref(aiOrderStore).active) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(aiOrderStore).effectStatusArr, (v) => {
                    return (_openBlock(), _createBlock(_component_var_tab, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t(`components.AIOrderTaskWindow.${v}`)), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 256))
                ]),
                _: 1
              }, 8, ["active"]),
              (_unref(aiOrderStore).data.total > 0)
                ? (_openBlock(), _createBlock(_component_var_table, {
                    key: 0,
                    "full-width": "80%",
                    "scroller-height": "50%"
                  }, {
                    footer: _withCtx(() => [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_var_pagination, {
                          "show-size-changer": false,
                          simple: false,
                          current: _unref(aiOrderStore).data.page,
                          "onUpdate:current": _cache[5] || (_cache[5] = ($event: any) => ((_unref(aiOrderStore).data.page) = $event)),
                          size: _unref(aiOrderStore).data.pageSize,
                          "onUpdate:size": _cache[6] || (_cache[6] = ($event: any) => ((_unref(aiOrderStore).data.pageSize) = $event)),
                          total: _unref(aiOrderStore).data.total
                        }, null, 8, ["current", "size", "total"])
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("thead", _hoisted_6, [
                        _createElementVNode("tr", _hoisted_7, [
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('components.AIOrderTaskWindow.rwd')), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('components.AIOrderTaskWindow.cp')), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('components.AIOrderTaskWindow.gmfy')), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('components.AIOrderTaskWindow.zsy')), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('components.AIOrderTaskWindow.rws')), 1),
                          (_unref(aiOrderStore).effectStatusArr[_unref(aiOrderStore).active] == 'finish')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("th", null, _toDisplayString(_ctx.$t('components.AIOrderTaskWindow.startTime')), 1),
                                _createElementVNode("th", null, _toDisplayString(_ctx.$t('components.AIOrderTaskWindow.overTime')), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock("th", _hoisted_8, _toDisplayString(_ctx.$t('components.AIOrderTaskWindow.yxsj')), 1))
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(aiOrderStore).data.list, (v, i) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: v.Id
                          }, [
                            _createElementVNode("td", null, [
                              _createVNode(_component_VarEllipsis, { style: {"max-width":"150px"} }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(v.OrderNumber), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(_component_VarEllipsis, { style: {"max-width":"150px"} }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(v.Product.Dn), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(_component_VarChip, {
                                size: "small",
                                type: "info"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_9, " $ " + _toDisplayString(_unref(Tools).TruncateDecimal(v.BuyCost ?? 0, 2)), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(_component_VarChip, {
                                size: "small",
                                type: (v.TotalAmount ?? 0) >= 0 ? 'success' : 'danger'
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_10, [
                                    _cache[8] || (_cache[8] = _createElementVNode("span", null, "$ ", -1)),
                                    _createVNode(_component_VarCountTo, {
                                      duration: 300,
                                      to: v.TotalAmount ?? 0,
                                      precision: 8
                                    }, null, 8, ["to"])
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["type"])
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(_component_VarChip, {
                                size: "small",
                                type: "primary"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(v.TotalTaskCount ?? 0), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            (_unref(aiOrderStore).effectStatusArr[_unref(aiOrderStore).active] == 'finish')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("td", null, _toDisplayString((v.StartTime && _unref(Tools).ConvertTimestamp(v.StartTime ?? 0)) || '--'), 1),
                                  _createElementVNode("td", null, _toDisplayString((v.OverTime && _unref(Tools).ConvertTimestamp(v.OverTime ?? 0)) || '--'), 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock("td", _hoisted_11, _toDisplayString(_unref(aiOrderStore).GetRunTime(v)), 1))
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(EmptyComponent, {
                    key: 1,
                    style: {"width":"80vw","height":"50vh"}
                  }))
            ]),
            _: 1
          }, 8, ["title"])
        ]),
        _: 1
      }, 8, ["show"]))
}
}

})